/* src/app/controls/progress-bar/progress-bar.component.css */
ul.nc-progress-bar {
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 0;
  list-style-type: none;
}
li.section {
  width: 20%;
  display: inline-block;
  padding-top: 45px;
  font-size: 11px;
  font-weight: bold;
  line-height: 14px;
  color: gray;
  vertical-align: top;
  position: relative;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
}
li.section:before {
  content: " ";
  position: absolute;
  top: 2px;
  left: calc(50% - 15px);
  z-index: 1;
  width: 25px;
  height: 25px;
  color: white;
  border: 2px solid white;
  border-radius: 17px;
  line-height: 25px;
  background: gray;
}
.status-bar {
  height: 2px;
  background: gray;
  position: relative;
  top: 16px;
  margin: 0 auto;
}
.current-status {
  height: 2px;
  width: 0;
  border-radius: 1px;
  background: #3b74b0;
}
@keyframes changeBackground {
  from {
    background: gray;
  }
  to {
    background: #3b74b0;
  }
}
li.section.visited:before {
  content: " ";
  animation: changeBackground 0.5s linear;
  animation-fill-mode: forwards;
}
li.section.visited.current:before {
  box-shadow: 0 0 0 2px #3b74b0;
}
/*# sourceMappingURL=progress-bar.component.css.map */
